// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planning_upper_container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  background-color: #f4f7fa;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  gap: 25px;
  flex-wrap: wrap;
}

.Select_service_sector,
.plannng_details_add_price {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  background: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.Select_service_sector select {
  padding: 1rem;
  font-size: 1rem;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  outline: none;
  transition: all 0.3s ease;
  appearance: none;
}

.plannng_details_add_price_input input {
  padding: 1rem;
  font-size: 1rem;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  outline: none;
  transition: all 0.3s ease;
}

.Planning_Add_master_button {
  padding: 1rem;
  background: linear-gradient(135deg, #6c63ff, #5a54d6);
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.Planning_Add_master_button:hover {
  background: linear-gradient(135deg, #5a54d6, #6c63ff);
}

@media (max-width: 480px) {
  .Select_service_sector,
  .plannng_details_add_price {
    padding: 0.8rem;
  }

  .Select_service_sector select,
  .plannng_details_add_price_input input,
  .Planning_Add_master_button {
    font-size: 0.95rem;
    padding: 0.85rem;
  }
}

/* ******** */
.planningDetails-main-wrapper {
  display: flex;
  justify-content: center;

  background-color: #f4f7fa;
  padding: 1rem;
}

.planningDetails-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.5rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.planningDetails-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.planningDetails-card {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #fafafa;
  transition: all 0.3s ease;
  cursor: pointer;
}

.planningDetails-card:hover {
  border-color: #3b82f6;
  background-color: #f0f7ff;
  transform: translateY(-2px);
}

.planningDetails-card input[type="radio"] {
  margin-right: 1rem;
  accent-color: #3b82f6;
  폭: 1.25rem;
  height: 1.25rem;
}

.planningDetails-card-content {
  flex: 1 1;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}

.planningDetails-card-content p {
  margin: 0;
  font-size: 0.875rem;
  color: #1f2937;
}

.planningDetails-card-content p strong {
  color: #111827;
  font-weight: 600;
}

.planningDetails-submit-button {
  align-self: center;
  padding: 0.75rem 1.5rem;
  background-color: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.planningDetails-submit-button:hover {
  background-color: #2563eb;
}

.planningDetails-submit-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
}

@media (max-width: 640px) {
  .planningDetails-container {
    padding: 1rem;
  }

  .planningDetails-card {
    flex-direction: column;
    align-items: flex-start;
    padding: 0.75rem;
  }

  .planningDetails-card input[type="radio"] {
    margin-bottom: 0.5rem;
  }

  .planningDetails-card-content {
    gap: 0.5rem;
  }

  .planningDetails-card-content p {
    font-size: 0.75rem;
  }

  .planningDetails-submit-button {
    width: 100%;
    padding: 0.75rem;
  }
}

@media (min-width: 641px) and (max-width: 1024px) {
  .planningDetails-container {
    max-width: 90%;
  }

  .planningDetails-card-content {
    grid-template-columns: 1fr 1fr;
  }

  .planningDetails-card-content p {
    font-size: 0.85rem;
  }

  .planningDetails-submit-button {
    padding: 0.75rem 2rem;
  }
}

@media (min-width: 1025px) {
  .planningDetails-card-content {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .planningDetails-card-content p {
    font-size: 0.875rem;
  }
}

.planningDetails-heading {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  text-align: center;
  margin-bottom: 1.5rem;
}

@media (max-width: 640px) {
  .planningDetails-heading {
    font-size: 1.25rem;
  }
}
/* ******** */
`, "",{"version":3,"sources":["webpack://./src/Planning/planningdetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;;;IAGE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;;EAEvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;AACA,aAAa","sourcesContent":[".planning_upper_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  background-color: #f4f7fa;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  gap: 25px;\n  flex-wrap: wrap;\n}\n\n.Select_service_sector,\n.plannng_details_add_price {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  background: #f9f9f9;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.Select_service_sector select {\n  padding: 1rem;\n  font-size: 1rem;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  outline: none;\n  transition: all 0.3s ease;\n  appearance: none;\n}\n\n.plannng_details_add_price_input input {\n  padding: 1rem;\n  font-size: 1rem;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.Planning_Add_master_button {\n  padding: 1rem;\n  background: linear-gradient(135deg, #6c63ff, #5a54d6);\n  color: #fff;\n  font-weight: 600;\n  font-size: 1rem;\n  text-align: center;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.Planning_Add_master_button:hover {\n  background: linear-gradient(135deg, #5a54d6, #6c63ff);\n}\n\n@media (max-width: 480px) {\n  .Select_service_sector,\n  .plannng_details_add_price {\n    padding: 0.8rem;\n  }\n\n  .Select_service_sector select,\n  .plannng_details_add_price_input input,\n  .Planning_Add_master_button {\n    font-size: 0.95rem;\n    padding: 0.85rem;\n  }\n}\n\n/* ******** */\n.planningDetails-main-wrapper {\n  display: flex;\n  justify-content: center;\n\n  background-color: #f4f7fa;\n  padding: 1rem;\n}\n\n.planningDetails-container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0.5rem;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.planningDetails-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.planningDetails-card {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background-color: #fafafa;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.planningDetails-card:hover {\n  border-color: #3b82f6;\n  background-color: #f0f7ff;\n  transform: translateY(-2px);\n}\n\n.planningDetails-card input[type=\"radio\"] {\n  margin-right: 1rem;\n  accent-color: #3b82f6;\n  폭: 1.25rem;\n  height: 1.25rem;\n}\n\n.planningDetails-card-content {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.75rem;\n}\n\n.planningDetails-card-content p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #1f2937;\n}\n\n.planningDetails-card-content p strong {\n  color: #111827;\n  font-weight: 600;\n}\n\n.planningDetails-submit-button {\n  align-self: center;\n  padding: 0.75rem 1.5rem;\n  background-color: #3b82f6;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.planningDetails-submit-button:hover {\n  background-color: #2563eb;\n}\n\n.planningDetails-submit-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);\n}\n\n@media (max-width: 640px) {\n  .planningDetails-container {\n    padding: 1rem;\n  }\n\n  .planningDetails-card {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0.75rem;\n  }\n\n  .planningDetails-card input[type=\"radio\"] {\n    margin-bottom: 0.5rem;\n  }\n\n  .planningDetails-card-content {\n    gap: 0.5rem;\n  }\n\n  .planningDetails-card-content p {\n    font-size: 0.75rem;\n  }\n\n  .planningDetails-submit-button {\n    width: 100%;\n    padding: 0.75rem;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 1024px) {\n  .planningDetails-container {\n    max-width: 90%;\n  }\n\n  .planningDetails-card-content {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .planningDetails-card-content p {\n    font-size: 0.85rem;\n  }\n\n  .planningDetails-submit-button {\n    padding: 0.75rem 2rem;\n  }\n}\n\n@media (min-width: 1025px) {\n  .planningDetails-card-content {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  .planningDetails-card-content p {\n    font-size: 0.875rem;\n  }\n}\n\n.planningDetails-heading {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #111827;\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n@media (max-width: 640px) {\n  .planningDetails-heading {\n    font-size: 1.25rem;\n  }\n}\n/* ******** */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
